/* global _ */
import Tool from '../script/tool.js'
const matchType = {
  2: '高级精确',
  3: '精确',
  4: '普通短语',
  5: '智能短语',
  6: '广泛',
  7: '短语-精确包含',
  8: '短语-同义包含'
}

const bidStatus = {
  0: '未添加',
  1: '已添加'
}

export default {
  methods: {
    transChangeWithCrowd () {
      if (this.clusterid) {
        this.heatbeat()
      } else {
        this.updatePage()
      }
    },
    // web模块sort方法
    tablesorter ({ key, order }) {
      this.sorter(key, order)
    },
    setDefaultDianjingID () {
      this.dianjingID = this.dianjingIDList[0].userId
      this.$store.commit('SET_DIANJINGID', this.dianjingID)
    },
    getSiteDianjingIDsWithoutWhole () {
      if (!this.$store.state.domainId) return
      const dianjingPromise = this.$http.get('/api/adv_system/list', {
        params: {
          domainId: this.$store.state.domainId,
          adsystem: 'dianjing'
        }
      })
      this.$store.dispatch('VUE_HTTP', [dianjingPromise]).then(res => {
        if (res) {
          const idlist = _.filter(res.list, item => item.bstatus === 1)
          if (idlist.length > 0) {
            this.dianjingIDList = idlist.map(item => {
              item.value = item.userId
              item.label = item.username
              return item
            })
            !this.dianjingID &&
              this.$nextTick(() => {
                this.setDefaultDianjingID()
              })
          } else {
            this.dianjingIDList = []
            this.$Modal.confirm('该账号未绑定点睛账号，无法查看相关数据。现在去绑定？', result => {
              if (result) {
                this.$router.push('/setting/user')
              }
            })
          }
        }
      })
    },
    getTimespan (start, end) {
      start.replace(/\//g, '-')
      end.replace(/\//g, '-')
      start = new Date(start)
      end = new Date(end)
      const timespan = end - start

      return timespan
    },
    dateToString (d, deliver = '/') {
      const m = d.getMonth() + 1
      const date = d.getDate()
      return [
        d.getFullYear(),
        m > 9 ? m : this.zeroPrefix(m),
        date > 9 ? date : this.zeroPrefix(date)
      ].join(deliver)
    },
    zeroPrefix (num, count = 1) {
      let res = ''
      _.map(_.range(count), function () {
        res += '0'
      })
      return res + num
    },
    getSomedayDateString (offset, deliver = '/') {
      const now = new Date()
      now.setDate(now.getDate() + offset)
      return this.dateToString(now, deliver)
    },
    getTimeArr (type, date) {
      let d = new Date()
      let num = d.getHours() + 1
      if (type === 'other') {
        // d.setDate(d.getDate() -1);
        d = new Date(date)
        num = 24
      }
      // 日期格式: 2015-10-01 01:00:00 整点格式
      return _.range(num).map(
        i =>
          `${this.dateToString(d, '-')} ${i < 10
            ? this.zeroPrefix(i)
            : i}:00:00`
      )
    },
    getDateArr (start, end) {
      const arr = []
      let tmp
      let flag = 366
      start = Date.parse(start)
      const d = new Date(start)
      d.setDate(d.getDate() - 1)
      while (true) {
        if (window.DEBUG) {
          flag--
          if (flag < 0) break
          console.warn('警报，警报，此处有 while( true )')
        }
        d.setDate(d.getDate() + 1)
        tmp = this.dateToString(d, '-')
        arr.push(`${tmp} 00:00:00`)
        if (tmp === end) break
      }
      return arr
    },
    getPeriodArr (period) {
      let dateArr = []
      if (!period || !period.start || !period.end) return

      const { start, end } = period
      if (start === end) {
        if (end === this.getSomedayDateString(0, '-')) {
          dateArr = this.getTimeArr()
        } else {
          dateArr = this.getTimeArr('other', start)
        }
      } else {
        dateArr = this.getDateArr(start, end)
      }
      return dateArr
    },
    fieldLoseData (period, list) {
      // 推广概览，搜索推广，展示广告页面中没有小时数据，所以不进行时间补充处理
      if (
        /^(\/web\/(promotion|addisplay|overall))|(\/app\/)/.test(
          this.$route.path
        ) &&
        period.start === period.end
      ) {
        return _.map(list, item => {
          item.date = item.date.split(' ')[0]
          return item
        })
      }
      return _.map(this.getPeriodArr(period), date => {
        let item = _.find(list, a => date.indexOf(a.date) > -1)
        if (!item) {
          item = {}
          // 拷贝一个cell 将cell的属性改成0
          _.assignIn(item, list[0])
          _.each(item, (v, k) => {
            // 非字符的全部改成0
            if (!isNaN(Number(v))) item[k] = 0
          })
        }
        item.date = date
        return item
      })
    },
    // 文本超过50字符显示title
    textEllipsidRender (index, value, item, type) {
      if (type === 'bid_status') {
        return bidStatus[value]
      }
      if (type === 'matchtype') {
        return matchType[value]
      }
      if (value && !_.isNull(value)) {
        return `<span title="${value}">${value}</span>`
      }
      return value || '-'
    },
    // 保留小数
    roundFloat (float, digits) {
      return parseFloat(float.toFixed(digits))
    },
    // 百分数
    percentRender (index, value, item) {
      if (_.isNull(value) || _.isUndefined(value)) {
        return '-'
      }
      return `${(value * 100).toFixed(2)}%`
    },
    // 平均访问时长render
    atimeRender (index, value, item) {
      if (isNaN(parseFloat(value))) {
        return '-'
      }
      const t = Math.ceil(value)
      let h, m, i
      h = m = i = 0
      i = t % 60
      if (t / 60 >= 1) {
        m = parseInt((t % 3600) / 60)
      }
      if (m) {
        h = parseInt(t / 3600)
      }
      return `${h < 10 ? `0${h}` : h}:${m < 10 ? `0${m}` : m}:${i < 10
        ? `0${i}`
        : i}`
    },
    // 增加checked字段
    addItemChecked (reportlist, compared = false) {
      return _.map(reportlist, (item, index) => {
        if (index === 0 && !this.sumChecked) {
          this.$set(item, 'checked', true)
        } else {
          this.$set(item, 'checked', false)
        }
        if (_.has(item, 'sdim_list') && item.sdim_list.length > 0) {
          _.map(item.sdim_list, (sdim, index) => {
            if (!compared) {
              this.$set(sdim, 'checked', false)
            }
            this.$set(sdim, 'name', sdim.sdimname)
            if (_.has(sdim, 'multiname')) {
              this.$set(sdim, 'multiname', sdim.sdimname)
            }
            return sdim
          })
        }
        return item
      })
    },
    putyAxisItem (indice) {
      const defaultFormatter = function (value, index) {
        return value
      }
      const timeFormatter = function (value, index) {
        const hours = Math.floor(value / (60*60))
        const minutes = Math.floor((value - hours * 60 * 60) / 60)
        const seconds = value % 60
        return `${hours === 0 ? '' : (hours + '小时')}${minutes === 0 ? '' : (minutes + '分')}${seconds === 0 ? '' : (seconds + '秒')}`
      }
      return {
        type: 'value',
        axisLabel: {
          formatter: indice === 'atime' ? timeFormatter : defaultFormatter
        }
      }
    },
    // 更新维度数据
    indiceChange: function (obj) {
      if (obj) {
        this.customIndice = obj.customIndice
        this.twoIndice = obj.twoIndice
      }
      let legendNames = []
      let xAxis = []
      let series = []
      const yAxis = []
      const customIndiceName = Tool.getIndexName(this.customIndice)
      if (!this.sumChecked && _.isEmpty(this.tableDataList)) {
        return
      }
      if (!_.isEmpty(this.chartResList)) {
        if (this.compared) {
          ;[legendNames, xAxis, series] = this.processContrastData(
            this.chartResList,
            [this.customIndice, customIndiceName]
          )
          xAxis = xAxis[0]
        } else if (this.twoIndiceSelectabled) {
          ;[legendNames, xAxis, series] = this.processMultiDimData(
            this.chartResList,
            this.customIndice
          )
        } else {
          ;[legendNames, xAxis, series] = this.processMultiIndicesData(
            this.chartResList,
            [this.customIndice, this.twoIndice === '_' ? '' : this.twoIndice]
          )
        }
      }
      /* setting yAxis */
      yAxis.push(this.putyAxisItem(this.customIndice))
      if (!(this.twoIndice === '_' || this.twoIndice === '')) {
        let newItem = this.putyAxisItem(this.twoIndice)
        newItem.splitLine = {
          show: false
        }
        yAxis.push(newItem)
      }
      this.yAxis = yAxis
      this.legend = legendNames
      this.chartXAxis = xAxis
      this.chartSeries = series
    },
    // 对比时间更新
    compRangeChange ({ compared, compStart, compEnd }) {
      this.compared = compared
      this.compareStart = compStart
      this.compareEnd = compEnd
      this.chartResList = []
      this.getTableData()
    },
    // 重置compared并获取数据
    resetCompared () {
      this.compared = false
      this.chartResList = []
      this.getTableData()
    },
    // 重置indice
    resetIndice () {
      if (!_.isEmpty(this.indicesMenu)) {
        this.chartResList = []
        this.twoIndice = this.indicesMenu[0].value
        this.customIndice = this.indicesMenu[1].value
      }
    },
    // 获取绘图数据
    fetchLineChartData () {
      this.$store.dispatch('SET_DRAWCHART', false)
      this.$store.dispatch('SET_CHART_LOADING', true)
      const checklist = this.$store.state.tableCheckList.filter(item => {
        return item.checked
      })
      this.$store.dispatch('SET_TABLE_CHECKLIST', checklist)
      const cond = this.getChartCond(checklist)
      // 判断cond中mdim和query中mdim是否相同, 部分页面中mdim是__分隔
      const condMdim = this.query.mdim.split('__')[0]
      const isCondHasMdim = condMdim === 'groupName' || cond.includes(condMdim) || cond.includes('sum') || cond.includes('trans')
      if (this.query.mdim && !isCondHasMdim) return
      this.twoIndiceShow = !(checklist.length > 1 || this.compared)
      if (!this.twoIndiceShow) {
        this.resetIndice()
      }
      let query = _.assignIn({ cond: cond }, this.query)
      if (this.sdim !== 'null') {
        query = _.assignIn(
          {
            sdim: this.sdim
          },
          query
        )
      }
      if (_.has(query, 'ps') || _.has(query, 'pg')) {
        this.$delete(query, 'ps')
        this.$delete(query, 'pg')
      }
      const linechartPromise = this.$http.get(
        _.find(this.tablist, { id: this.currentTab }).reportLineChartApi,
        { params: query }
      )
      this.$store.dispatch('VUE_HTTP', [linechartPromise]).then(res => {
        if (res) {
          this.chartResList = res.list
          this.indiceChange()
          this.$store.dispatch('SET_CHART_LOADING', false)
        }
      })
    },
    // 验证是否是mv网站
    checkDomainType () {
      if (!this.domainId) return
      const checkDomainPromise = this.$http.get('/api/report/checkDomainType', {
        params: {
          cycle: 'hour',
          domainId: this.domainId,
          timespan: new Date().getTime()
        }
      })
      this.$store.dispatch('VUE_HTTP', [checkDomainPromise]).then(res => {
        if (res) {
          this.mvDemian = res.domaintype !== 0
        }
      })
    },
    // 列表渲染
    columnRender (index, value, item) {
      return !_.isNull(value) && !_.isUndefined(value)
        ? this.roundFloat(value, 2)
        : '-'
    },
    // 排序事件
    sorter (key, order) {
      this.isasc = order
      this.order = key
      this.getTableData()
    },
    // 二级维度切换事件
    sdimChange () {
      this.order = _.find(this.tablist, { id: this.currentTab }).order
      this.isasc = 0
      this.getTableData()
    },
    // tab切换通用处理
    resetTab (tab) {
      this.currentTab = tab
      this.order = _.find(this.tablist, { id: this.currentTab }).order
      this.isasc = 0
      this.compared = false
      this.sdim = 'null'
    },
    // advice table中将当前项计入tablechecklist中
    pushItemIntoCheckList (item) {
      this.$set(item, 'checked', true)
      const list = _.concat([], this.$store.state.tableCheckList)
      list.push(item)
      this.$store.dispatch('SET_TABLE_CHECKLIST', _.uniqBy(list, 'id'))
    },
    // 获取表格中汇总和详情数据
    getTableData (pn = 1) {
      this.pg = pn

      if (/^\/web/.test(this.$route.path) && !this.domainId) return
      this.$store.dispatch('SET_TABLE_CHECKLIST', [])
      this.$store.dispatch('SET_TABLE_LOADING', true)
      this.total = 0
      const sumParams = _.assignIn({}, this.query)
      const listParams = _.assignIn(
        {
          pg: this.pg,
          ps: this.ps
        },
        this.query
      )

      this.getOtherList && this.getOtherList()
      const SummaryStatPromise = this.$http.get(
        _.find(this.tablist, { id: this.currentTab }).basicSummaryStatApi,
        { params: sumParams }
      )
      const reportTablePromise = this.$http.get(
        _.find(this.tablist, { id: this.currentTab }).reportTableApi,
        { params: listParams }
      )
      this.$store
        .dispatch('VUE_HTTP', [SummaryStatPromise, reportTablePromise])
        .then(res => {
          // 判断当前tab与请求的mdim是否相同
          if (listParams.mdim === this.currentTab && res && res.length === 2) {
            const [summary, report] = res
            const summarylist = summary.list
            const reportlist = report.list || []
            this.total = report.total

            this.sdimOptions = this.getSdimOptionList(report.ext_info)

            if (this.compared) {
              summarylist[0].checked = true
              this.sum = {
                sum: summarylist[0],
                defaultSum: summarylist[0].comp_list[0],
                comparedSum: summarylist[0].comp_list[1]
              }
            } else {
              if (!_.isEmpty(summarylist) && _.has(summarylist[0], 'sdim_list') && this.sumChecked) {
                _.map(summarylist[0].sdim_list, (sdim, index) => {
                  this.$set(sdim, 'checked', false)
                  return sdim
                })
                summarylist[0].checked = true
              }
              this.sum = summarylist[0] || {}
            }
            // 增加checked字段，将第一个放入checklist中
            // 补充二级维度数据
            this.tableDataList = this.addItemChecked(reportlist, this.compared)

            if (this.sumChecked) {
              const checklist = this.compared ? _.concat([], this.sum.sum) : _.concat([], summarylist[0])
              this.$store.dispatch('SET_TABLE_CHECKLIST', checklist)
              this.fetchLineChartData()
            } else if (this.tableDataList.length > 0) {
              const checklist = _.concat([], reportlist[0])
              this.$store.dispatch('SET_TABLE_CHECKLIST', checklist)
              this.fetchLineChartData()
            } else {
              // 清空画图数据
              this.legend = []
              this.chartXAxis = []
              this.chartSeries = []
            }
          } else {
            this.sum = {}
            this.tableDataList = []
            this.$store.dispatch('SET_TABLE_CHECKLIST', [])
            this.legend = []
            this.chartXAxis = []
            this.chartSeries = []
            if (this.currentTab !== listParams.mdim) {
              this.getTableData()
            }
          }
          this.$store.dispatch('SET_TABLE_LOADING', false)
          if (this.calcLoading) {
            this.calcLoading = false
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    // 获取网站有效绑定的点睛账号列表
    getSiteDianjingIDs () {
      if (!this.$store.state.domainId) return
      const dianjingPromise = this.$http.get('/api/adv_system/list', {
        params: {
          domainId: this.$store.state.domainId,
          adsystem: 'dianjing'
        }
      })
      this.dianjingID = 0
      this.$store.dispatch('VUE_HTTP', [dianjingPromise]).then(res => {
        if (res) {
          const idlist = _.filter(res.list, item => item.bstatus === 1)
          if (idlist.length > 0) {
            this.dianjingIDList = _.concat(
              [{ userId: 0, username: '全部' }],
              idlist
            ).map(item => {
              item.value = item.userId
              item.label = item.username
              return item
            })
          } else {
            this.$Modal.confirm('该账号未绑定点睛账号，无法查看相关数据。现在去绑定？', result => {
              if (result) {
                this.$router.push('/setting/user')
              }
            })
          }
        }
      })
    },

    // 获取账号有效绑定的点睛账号列表
    getDianjingIDs () {
      const dianjingPromise = this.$http.get('/api/booladsystem/list')
      this.$store.dispatch('VUE_HTTP', [dianjingPromise]).then(res => {
        if (res) {
          const idlist = _.filter(res.list, item => item.bstatus === 1)
          if (idlist.length > 0) {
            const dianjingIDList = _.concat(
              [{ userId: 0, username: '全部' }],
              idlist
            ).map(item => {
              item.value = item.userId
              item.label = item.username
              return item
            })
            this.setDinajingIdList(dianjingIDList)
          } else {
            this.$Modal.confirm('该账号未绑定点睛账号，无法查看相关数据。现在去绑定？', result => {
              if (result) {
                this.$router.push('/setting/appuser')
              }
            })
          }
        }
      })
    },
    // 应用推广页面中获取数据方法
    getAppData () {
      if (this.dianjingIDList.length > 1) {
        // 获取table数据
        this.resetCompared()
      }
    },

    // 获取二级维度选择列表
    getSdimOptionList (list) {
      const newSdimList = []
      if (_.has(list, 'sdim')) {
        _.map(list.sdim, item => {
          const newItem = {
            value: _.isNull(item.id) ? 'null' : item.id,
            title: item.name
          }
          newSdimList.push(newItem)
        })
      }
      return newSdimList
    },
    // 重组columns
    getRecombineColumns (customColumns, tableIndices) {
      return _.filter(customColumns, item => {
        const newItem = _.filter(item.children, child => {
          if (tableIndices.includes(child.key)) {
            return child
          }
        })
        item.children = newItem
        if (item.children.length > 0) {
          return item
        }
      })
    },
    // 获取默认的列配置
    getCustomColumns ({ hasSpread }) {
      const spreadColumns = [
        {
          title: '推广指标',
          children: [
            {
              title: '展现量',
              key: 'adpv',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '点击量',
              key: 'adclick',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '点击率',
              key: 'adctr',
              class: 'right',
              sorter: this.sorter,
              render: this.percentRender
            },
            {
              title: '消费',
              key: 'adcost',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: 'CPC',
              key: 'adcpc',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: 'CPM',
              key: 'adcpm',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            }
          ]
        }
      ]
      const defaultColumns = [
        {
          title: '基础流量指标',
          children: [
            {
              title: '浏览量(PV)',
              key: 'pv',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '访客数(UV)',
              key: 'uv',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: 'IP',
              key: 'ipnum',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '新独立访客',
              key: 'newvst',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '访问次数',
              key: 'vnum',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '到达率',
              key: 'reachrate',
              class: 'right',
              render: this.percentRender
            }
          ]
        },
        {
          title: '流量质量指标',
          children: [
            {
              title: '平均访问时长',
              key: 'atime',
              class: 'right',
              sorter: this.sorter,
              render: this.atimeRender
            },
            {
              title: '平均访问页数',
              key: 'anum',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '入口页次数',
              key: 'innum',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '退出页次数',
              key: 'exitnum',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '退出率',
              key: 'exitrate',
              class: 'right',
              sorter: this.sorter,
              render: this.percentRender
            },
            {
              title: '跳出率',
              class: 'right',
              key: 'jrate',
              sorter: this.sorter,
              render: this.percentRender
            }
          ]
        },
        {
          title: '系统转化指标',
          children: [
            {
              title: '订单量',
              key: 'ordernum',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '订单转化率',
              key: 'orderrate',
              class: 'right',
              sorter: this.sorter,
              render: this.percentRender
            },
            {
              title: '订单金额',
              key: 'orderprice',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '注册量',
              key: 'reg',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '注册转化率',
              key: 'regrate',
              class: 'right',
              sorter: this.sorter,
              render: this.percentRender
            }
          ]
        },
        {
          title: '自定义转化指标',
          key: 'custom',
          width: 250,
          children: [
            {
              title: '自定义转化次数',
              key: 'tnum',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '转化率',
              key: 'trate',
              class: 'right',
              sorter: this.sorter,
              render: this.percentRender
            }
          ]
        }
      ]
      if (hasSpread) {
        return _.concat([], spreadColumns, defaultColumns)
      }
      return defaultColumns
    },
    // 获取画图参数
    getChartCond (list) {
      const lineChartOptions = _.map(list, row => {
        const mdimList = row.mdim.split('__')
        // 部分页面中mdim是用__分隔多个主维度
        const result = mdimList.reduce((result, item, index) => {
          const replaceObj = {
            groupName: 'groupId',
            plan: 'planId',
            advert: 'advertId'
          }
          item = _.has(replaceObj, item) ? replaceObj[item] : item
          return _.concat(result, [
            /* eslint-disable no-undefined */
            row[item] ? 'm' : undefined,
            row[item] ? item : undefined,
            row[item] ? encodeURIComponent(row[item]) : undefined
          ]).filter(item => item !== undefined)
        }, [])
        return _.concat(result, [
          row.sdim ? 's' : undefined,
          row.sdim,
          row[row.sdim] ? encodeURIComponent(row[row.sdim]) : undefined,

          row.cdim ? 'c' : undefined,
          row.cdim,
          row[row.cdim] ? encodeURIComponent(row[row.cdim]) : undefined
        ]).filter(item => item !== undefined)
      })
      const cond = _.map(lineChartOptions, option => {
        return option.join('|')
      }).join(':')
      return cond
    },
    /*
         * 预处理多个维度中某一个指标的数据
         * @arg {Array<Object>} lineDatas - 折线图的原始数据，多个维度的数据混合在一起, 只包含有效的数据值,
         * @arg {Array<String>} selectedIndices - 所选择的指标，只能有一个
         */

    processMultiDimData (lineDatas, selectedIndice) {
      const legendNames = _.uniq(_.map(lineDatas, 'name')) // 由数据的 name 属性获取图例数据
      // 原来维度区分使用的是key，现在使用name，name保证了唯一性
      let seperareLineDatas = _.values(_.groupBy(lineDatas, 'name'))
      // 每一维度的数据是一个数组
      let xAxis = [] // 根据时间信息生成 x 轴的数据
      const series = [] // 折线图中要用的系列数据
      // colors = lineColorFactory(); //颜色数据
      // 将数据按照时间补齐，没有数据的地方给 0
      seperareLineDatas = _.map(seperareLineDatas, linedata => {
        return this.fieldLoseData(
          { start: this.$store.state.start, end: this.$store.state.end },
          linedata
        )
      })
      xAxis = _.map(seperareLineDatas[0], item => {
        if (this.$store.state.start === this.$store.state.end) {
          return item.date
        }
        return item.date.split(' ')[0]
      })
      // 由 lineDatas 生成 seriesDatas
      _.forEach(seperareLineDatas, (lineData, i) => {
        const seriesData = _.map(lineData, selectedIndice)
        series.push({ name: lineData[0].name, data: seriesData })
      })
      return [legendNames, xAxis, series]
    },
    /*
         * 预处理一个维度中多个指标的数据
         * @arg {Array<Object>} lineDatas - 折线图的原始数据，包含一个维度的数据，只包含有效的数据值
         * @arg {Array<String>} selectedIndices - 所选择的指标，可以有一个或两个
         */

    processMultiIndicesData (lineDatas, selectedIndices) {
      selectedIndices = _.filter(selectedIndices, indice => indice !== '')
      let legendNames = _.map(selectedIndices, indice =>
        Tool.getIndexName(indice)
      )
      const [dataName] = _.uniq(_.map(lineDatas, 'name'))
      // 由数据的 name 属性获取图例数据
      let xAxis = [] // 根据时间信息生成 x 轴的数据
      const series = [] // 折线图中要用的系列数据
      legendNames = _.map(legendNames, name => `${dataName} - ${name}`)
      // 将数据按照时间补齐，没有数据的地方给 0
      lineDatas = this.fieldLoseData(
        { start: this.$store.state.start, end: this.$store.state.end },
        lineDatas
      )
      xAxis = _.map(lineDatas, item => {
        if (this.$store.state.start === this.$store.state.end) {
          return item.date
        }
        return item.date.split(' ')[0]
      })
      // 由 lineDatas 生成 seriesDatas
      _.forEach(selectedIndices, (selectedIndice, i) => {
        const seriesData = _.map(lineDatas, selectedIndice)
        // 第二组数据需增加yAxisIndex
        if (i === 0) {
          series.push({ name: legendNames[i], data: seriesData })
        } else {
          series.push({ name: legendNames[i], yAxisIndex: i, data: seriesData })
        }
      })
      return [legendNames, xAxis, series]
    },
    processContrastData (lineDatas, selectedIndice) {
      // let legendNames         = _.uniq( _.map( lineDatas, 'name' ) ), //由数据的 name 属性获取图例数据
      const legendNames = [selectedIndice[1], `对比${selectedIndice[1]}`]
      const groupByData = _.groupBy(lineDatas, 'name')
      const seperareKeys = _.keys(groupByData)
      let seperareLineDatas = [] // 每一维度的数据是一个数组
      const xAxis = [] // 根据时间信息生成 x 轴的数据
      const series = [] // 折线图中要用的系列数据
      const today = this.getSomedayDateString(0) // 此处的时间格式为 2016/05/14
      const todayDash = this.getSomedayDateString(0, '-')
      // 通用方法中需要的时间参数格式为 2016-05-14
      const todayPeriod = `${today}-${today}`
      // 拼出今天的时间格式, 形如 2016/05/14-2016/05/14

      if (!/^\d{4}\/\d{2}\/\d{2}-\d{4}\/\d{2}\/\d{2}$/g.test(seperareKeys[0])) {
        return [legendNames, xAxis, series]
      }

      _.forEach(seperareKeys, (key, i) => {
        // 如果对比日期中有今天， 可能是当期，也可能是对比期
        if (key === todayPeriod) {
          // 补充数据截至到当前时刻，如果当前时刻是 15:00，不补充 16:00 之后的数据
          groupByData[key] = this.fieldLoseData(
            { start: todayDash, end: todayDash },
            groupByData[key]
          )
          // x 轴的数据要是完整的，从 00:00 到 23:00
          xAxis[i] = this.getTimeArr('other', todayDash)
        } else {
          // key 的格式形如 2016/05/14-2016/05/14, 需要将斜线替换为横线
          const dateArr = _.map(key.split('-'), date =>
            date.replace(/\//g, '-')
          )
          groupByData[key] = this.fieldLoseData(
            { start: dateArr[0], end: dateArr[1] },
            groupByData[key]
          )
          xAxis[i] = _.map(groupByData[key], item => {
            if (this.$store.state.start === this.$store.state.end) {
              return item.date
            }
            return item.date.split(' ')[0]
          })
        }
      })
      seperareLineDatas = _.values(groupByData)
      // 由 lineDatas 生成 seriesDatas
      _.forEach(seperareLineDatas, (lineData, i) => {
        const seriesData = _.map(lineData, selectedIndice[0])
        // lineOpt.name = lineData[0].name
        const name = i === 0 ? selectedIndice[1] : `对比${selectedIndice[1]}`
        series.push({ name: name, data: seriesData, xAxisIndex: i })
      })
      return [legendNames, xAxis, series]
    },
    /* 一个维度单一指标 */
    processPredictData ({
      history,
      trend,
      oplog,
      selectedIndice,
      predLegend = '预估数据'
    }) {
      let lineDatas = history
      const predLineDatas = _.sortBy(trend, ['date'])
      const legendNames = [Tool.getIndexName(selectedIndice), predLegend]
      let xAxis = [] // 根据时间信息生成 x 轴的数据
      let lineXAxis = []
      let predSeries = []
      let series = [] // 折线图中要用的系列数据
      // 预估区域
      const areaXAxis = [
        [
          {
            name: '预估',
            xAxis: predLineDatas[0].date.split(' ')[0]
          },
          {
            xAxis: predLineDatas[predLineDatas.length - 1].date.split(' ')[0]
          }
        ]
      ]
      let xAxisData = lineDatas
      // 将数据按照时间补齐，没有数据的地方给 0
      lineDatas = this.fieldLoseData(
        { start: this.$store.state.start, end: this.$store.state.end },
        lineDatas
      )
      // 优化点画线
      lineXAxis = _.map(_.uniqBy(oplog, 'date'), item => {
        return {
          name: '优化',
          xAxis: item.date.split(' ')[0]
        }
      })
      xAxisData = _.uniqBy(_.concat(lineDatas, predLineDatas), 'date').map(
        item => item.date
      )

      _.forEach(xAxisData, (item, i) => {
        series.push(
          _.find(lineDatas, { date: item })
            ? _.find(lineDatas, { date: item })[selectedIndice]
            : '-'
        )
        predSeries.push(
          _.find(predLineDatas, { date: item })
            ? _.find(predLineDatas, { date: item })[selectedIndice]
            : '-'
        )
      })

      xAxis = _.map(xAxisData, item => {
        return item.split(' ')[0]
      })
      // 如果是点击率，保留4位小数
      if (selectedIndice === 'adctr') {
        series = _.map(series, item => {
          if (item !== '-') {
            item = parseFloat(item).toFixed(4)
          }
          return item
        })
        predSeries = _.map(predSeries, item => {
          if (item !== '-') {
            item = parseFloat(item).toFixed(4)
          }
          return item
        })
      }
      return [legendNames, xAxis, series, predSeries, lineXAxis, areaXAxis]
    },
    // 后续对图中数据统一做处理
    seriesDataFormat (indice, data) {
      if (indice === 'adctr' || indice === 'trate') {
        data = parseFloat(data, 10).toFixed(4)
      } else if (indice === 'adcost') {
        data = parseFloat(data, 10).toFixed(2)
      } else {
        data = parseInt(data, 10)
      }
      return data
    },
    clearKeyword () {
      this.keyword = ''
      if (document.querySelector('.search')) {
        document.querySelector('.search').children[0].children[0].value = ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pageview/mixin.js